import type { AccountSource } from 'owa-account-source-list-store';
import { lazyHasEnterpriseOrPremiumLicense } from 'owa-has-enterprise-or-premium-license';
import markHasInitialized from '../mutators/markHasInitialized';
import { updateEnterpriseOrPremiumLicenseStatus } from '../mutators/updateEnterpriseOrPremiumLicenseStatus';
import { getEnterpriseOrPremiumLicenseStatus } from '../selectors/getEnterpriseOrPremiumLicenseStatus';

export async function computeEnterpriseOrPremiumLicenseStatus(
    accountSourceToBeExcluded?: AccountSource
): Promise<void> {
    markHasInitialized();

    const hasLicense =
        await lazyHasEnterpriseOrPremiumLicense.importAndExecute(accountSourceToBeExcluded);
    const computedStatus = hasLicense
        ? 'HasEnterpriseOrPremiumLicense'
        : 'NoEnterpriseOrPremiumLicense';

    const currentStatus = getEnterpriseOrPremiumLicenseStatus();
    if (computedStatus === currentStatus) {
        return;
    }

    updateEnterpriseOrPremiumLicenseStatus(computedStatus);
}
